// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "assets/" + (chunkId === 2143 ? "app" : chunkId) + ".css";
};